<template>
  <div class="company">
    <!-- 上面部分 -->
    <div
      class="newsMain"
      v-show="showList"
      @click="viewDetail(newsList[0],0)"
      style="cursor: pointer;"
    >
      <div class="left">
        <img src="../../../../assets/xinwenmoren.png" alt="" >
      </div>
      <!-- <div class="left" v-if="newsList[0].thumbnail!==''">
        <img :src="newsList[0].thumbnail" alt="" style="width: 100%; height: 344px;">
      </div> -->
      <div class="message">
        <p class="title">{{newsList.length>0?newsList[0].title:''}}</p>
        <p class="content">{{newsList.length>0?newsList[0].summary:''}}</p>
        <div class="bottom">
          <span>发布时间：{{ newsList.length>0?newsList[0].publishtime:''}}</span>
        </div>
      </div>
    </div>
    <!-- 新闻列表 -->
    <div class="newsDate">
      <div
        :class="classList[index].news_other"
        v-for="(item, index) in newsList"
        :key="item.ID"
        v-show="index != 0 && showList"
        @mouseover="changeActive(index)"
        @mouseleave="changeUnActive(index)"
        @click="viewDetail(item,index)"
      >
        <div :class="classList[index].news_other_time">
          <p class="time">{{ item.month }}</p>
          <p class="date">{{ item.day }}</p>
        </div>
        <div class="right">
          <p :class="classList[index].news_title_1">{{ item.title }}</p>
          <p>{{ item.summary }}</p>
        </div>
      </div>
    </div>
    <!-- 新闻详情 -->
    <div v-if="!showList">
      <div
        style="text-align:center;color:#000;font-size:24px;"
      >{{ newsList[index].title }}</div>
      <div class="center">
        <div class="left">
          发布日期:
          <span>{{ newsList[index].publishtime }}</span>
        </div>
        <div class="right">
          浏览次数：
          <span>{{newsList[index].clickNum}}</span>
        </div>
      </div>
      <div style="height:1px;background-color:#ccc;margin:20px 0;"></div>
      <div  v-html="newsList[index].content"  id="father_box"  ref="father_div"></div>
      <div style="text-align:center;">
        <span
          style="display:inline-block;color:rgba(0,104,183,1);cursor: pointer;"
          @click="showList = true;getNews()"
        >【返回列表】</span>
      </div>
      <div class="text">
        <div class="left" @click="clickLast">
          上一篇:
          <span style="cursor: pointer;">{{ newsList[index].title }}</span>
        </div>
        <div class="right" @click="clickNext">
          下一篇:
          <span style="cursor: pointer;">{{ newsList[index].title }}</span>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <el-pagination
      v-show="showList"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="5"
      layout="total, prev, pager, next, jumper"
      :total="totalCount"
      class="news-pagination"
      style="float: right;margin-bottom: 20px"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      currentPage: 1,
      totalCount: 0,
      id: '',

      newsList: [],
      classList: [
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1'
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1'
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1'
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1'
        },
        {
          news_other: 'news-other',
          news_other_time: 'news-other-time',
          news_title_1: 'news-title-1'
        }
      ],
      showList: true,
      content: '',
      index: 0
    }
  },
  mounted() {
    this.getNews();  
  },
  methods: {
    clickLast() {
      if (this.index !== 0) {
        --this.index
        this.id = this.newsList[this.index].ID
        this.addClickNum()
      }
    },
    clickNext() {
      if (this.index !== 4) {
        ++this.index
        this.id = this.newsList[this.index].ID
        this.addClickNum()
      }
    },
    // 查询新闻详情
    viewDetail(item, index) {     
      const vm = this
      vm.showList = false
      vm.content = item.content
      vm.index = index
      vm.id = item.ID

      this.addClickNum()
    },

    handleCurrentChange(val) {
      const vm = this
      vm.currentPage = val
      vm.getNews()
    },

    // 获取新闻列表
    getNews() {
      const vm = this
      let params = {
        pageNo: vm.currentPage,
        pageSize: 5,
        typevalue: '1'
      }
      vm.axios.get('/news/queryNewsList', { params: params }).then(res => {        
        vm.newsList = []
        res.data.newsList.list.forEach(val => {
          val.publishtime = val.publishtime
            ? moment(val.publishtime)
                .utc(0)
                .format('YYYY/MM/DD')
            : ''
          val.day = val.publishtime.split('/')[2]
          val.month =
            val.publishtime.split('/')[0] + '/' + val.publishtime.split('/')[1]
          vm.newsList.push(val)
          console.log(vm.newsList,'vm.newsList');
        })
        vm.totalCount = res.data.newsList.count[0].count     
      })
    },

    // 点击量接口
    addClickNum() {
      const vm = this
      let params = {
        articleId: vm.id
      }
      vm.axios.post('/news/addClickNum', { params }).then(res => {       
      })
    },
    changeActive(index) {
      let vm = this
      let class_active = {
        news_other: 'news-other-active',
        news_other_time: 'news-other-time-active',
        news_title_1: 'news-title-1-active'
      }
      vm.$set(vm.classList, index, class_active)
    },

    changeUnActive(index) {
      let vm = this
      let class_unactive = {
        news_other: 'news-other',
        news_other_time: 'news-other-time',
        news_title_1: 'news-title-1'
      }
      vm.$set(vm.classList, index, class_unactive)
    }
  }
}
</script>

<style lang="scss" scoped>
#father_box{
   padding: 0 300px;
}
#father_box  >>> p{    
      text-indent: 2rem;
      font-size: 18px !important;
       color: #666 !important;
      line-height: 28px;
      img{
         margin: 15px auto  !important;
         display: flex;
         justify-content: center;
      }
}
#father_box  >>> h1,h2,h3,h4,h5,h6{    
      text-indent: 2rem;
      font-size: 18px !important;
       color: #666 !important;
      line-height: 28px;
}


.company {
  padding: 0 8%;
  padding-top: 90px;
  .newsMain {
    background-color: #e5f0f8;
    display: flex;
    .left {
      width: 500px;
    }
    .message {
      padding: 0 20px;
      flex: 1;
      position: relative;
      color: #333333;
      margin-top: 20px;
      .title {
        font-size: 24px;
        color: #0068b7;
      }
      .content {
        margin-top: 20px;
      }
      .bottom {
        position: absolute;
        bottom: 20px;
        width: 95%;
        .more {
          float: right;
          color: #0068b7;
          cursor: pointer;
        }
      }
    }
  }
  .newsDate {
    padding-top: 54px;
    .news-other {
      display: flex;
      margin-bottom: 30px;
      cursor: pointer;
      .news-other-time {
        width: 180px;
        height: 110px;
        text-align: center;
        background-color: #999;
        color: #fff;
        margin-right: 60px;
        .time {
          height: 45px;
          line-height: 55px;
        }
        .date {
          font-size: 28px;
          font-weight: 700;
        }
      }
      .right {
        flex: 1;
        height: 110px;
        border-bottom: 1px solid #999999;
        font-size: 14px;
        color: #666666;
        .news-title-1 {
          height: 44px;
          line-height: 44px;
          font-size: 16px;
          color: #333333;
          font-size: 18px;
          font-weight: 700;
        }
      }
    }

    .news-other-active {
      display: flex;
      margin-bottom: 30px;
      cursor: pointer;
      .news-other-time-active {
        width: 180px;
        height: 110px;
        text-align: center;
        background-color: #0068b7;
        color: #fff;
        margin-right: 60px;
        .time {
          height: 45px;
          line-height: 55px;
        }
        .date {
          font-size: 28px;
          font-weight: 700;
        }
      }
      .right {
        flex: 1;
        height: 110px;
        border-bottom: 1px solid #0068b7;
        font-size: 14px;
        color: #666666;
        .news-title-1-active {
          height: 44px;
          line-height: 44px;
          font-size: 16px;
          color: #0068b7;
          font-size: 18px;
          font-weight: 700;
        }
      }
    }
  }
}

.center {
  display: flex;
  justify-content: center;
  text-align: center;
  margin: 30px 0;

  .left {
    margin-right: 50px;
  }
}

.text {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin: 30px 0;

  .left {
    width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .right {
    width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<style lang="scss">
.company {
  .el-image {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/news/component/company.vue